const AUTO_SIGN_IN_KEY = 'traceira-auto-sign-in-at';
const AUTO_SIGN_IN_WINDOW_MS = 60_000;

// Remembered per browser so an expired session returns through the same provider.
export const LAST_PROVIDER_KEY = 'traceira-sign-in-provider';

export function loginUrl(redirect: string, provider = '') {
  return `/api/v0/auth/login?redirect=${encodeURIComponent(redirect)}${
    provider ? `&provider=${encodeURIComponent(provider)}` : ''
  }`;
}

/**
 * Allows one automatic return to the identity provider per minute. A second expiry inside the
 * window falls back to the Sign in button, so a provider that never issues a usable session
 * cannot loop the browser.
 */
export function claimAutoSignIn(now = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(AUTO_SIGN_IN_KEY));
    if (last && now - last < AUTO_SIGN_IN_WINDOW_MS) return false;
    sessionStorage.setItem(AUTO_SIGN_IN_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}

/**
 * Where an ended session goes: straight to the provider, whose own session usually still holds,
 * so the person lands back on `returnPath` without seeing Sign in. Only a repeat expiry inside the
 * loop window shows the Sign in page.
 */
export function expiredSessionHref(returnPath: string) {
  if (!claimAutoSignIn())
    return `/sign-in?error=session_expired&redirect=${encodeURIComponent(returnPath)}`;
  let provider = '';
  try {
    provider = localStorage.getItem(LAST_PROVIDER_KEY) ?? '';
  } catch {
    // Without storage, the provider's own page asks which account.
  }
  return loginUrl(returnPath, provider);
}

export function redirectToExpiredSignIn(returnPath: string) {
  window.location.assign(expiredSessionHref(returnPath));
}
